const networks = {
  1: 'Ethereum Mainnet',
  5: 'Goerli',
  42: 'Kovan',
  56: 'Binance Smart Chain',
  97: 'Binance Smart Chain - Testnet',
  137: 'Polygon Mainnet',
  80001: 'Polygon Testnet Mumbai',
  1337: 'Localhost',
  123456: 'Localhost',
  31337: 'Localhost',
}

const contractAddress = {
  1: process.env.CONTRACT_ADDRESS_NFT || '',
  5: process.env.CONTRACT_ADDRESS_NFT,
  // Localhost for new hardhat integration
  31337: process.env.CONTRACT_ADDRESS_NFT || '',
}

const contractNSTAddress = {
  1: process.env.CONTRACT_ADDRESS_NST || '',
  5: process.env.CONTRACT_ADDRESS_NST,
  // Localhost for new hardhat integration
  31337: process.env.CONTRACT_ADDRESS_NST || '',
}

const contractBreedingManagerAddress = {
  1: process.env.CONTRACT_ADDRESS_BREEDING_MANAGER || '',
  5: process.env.CONTRACT_ADDRESS_BREEDING_MANAGER,
  // Localhost for new hardhat integration 
  31337: process.env.CONTRACT_ADDRESS_BREEDING_MANAGER || '',
}

const NetworkService = {
  networks,

  async getCurrentNetwork() {
    const networkId = await this.getNetworkId();
    return networks[networkId] || `Unknown network (ID: ${networkId})`;
  },

  async getNetworkId() {
    return Promise.resolve(window.web3.eth.net.getId());
  },

  getNetworkById(networkId) {
    return networks[networkId] || `Unknown network (ID: ${networkId})`;
  },

  getContractAddress(networkId) {
    return contractAddress[networkId];
  },

  getContractNSTAddress(networkId) {
    return contractNSTAddress[networkId];
  },

  getContractBreedingManagerAddress(networkId) {
    return contractBreedingManagerAddress[networkId];
  }
}

export default NetworkService;
